import { render, staticRenderFns } from "./Cabinet.vue?vue&type=template&id=5b30342a&scoped=true&"
import script from "./Cabinet.vue?vue&type=script&lang=js&"
export * from "./Cabinet.vue?vue&type=script&lang=js&"
import style0 from "./Cabinet.vue?vue&type=style&index=0&id=5b30342a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30342a",
  null
  
)

export default component.exports